<template>
    <div class="financeApplication__form">
        <ValidationObserver ref="observer">
            <div :class="classNames">
                <ValidationProvider
                    name="employer"
                    :rules="validationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="employer"
                        label="Employer"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            id="employer"
                            placeholder="Enter Employers' Name"
                            v-model="employer"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>

                <ValidationProvider
                    name="job title"
                    :rules="validationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="jobTitle"
                        label="Job Title"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            id="jobTitle"
                            placeholder="Enter Job Title"
                            v-model="jobTitle"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FinanceApplicationText from './FinanceApplicationText.vue'
import FinanceApplicationRow from './FinanceApplicationRow.vue'

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        FinanceApplicationRow,
        FinanceApplicationText,
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number
        }
    },
    data() {
        return {
            employer: this.initialValues.employment.employer,
            jobTitle: this.initialValues.employment.jobTitle
        }
    },
    methods: {
        async onChange({ key, value }) {
            this.$emit('change-employment', {
                key: this.initialValues.index,
                value: {
                    ...this.initialValues.employment,
                    [key]: value
                }
            })

            const valid = await this.$refs.observer.validate()

            this.$emit('validate', {
                key: `employmentEmployer${this.initialValues.index}`,
                valid
            })
        }
    },
    computed: {
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 670) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        validationRules() {
            return {
                required: true,
            }
        },
    },
    watch: {
        employer(value) {
            this.onChange({
                key: 'employer',
                value
            })
        },
        jobTitle(value) {
            this.onChange({
                key: 'jobTitle',
                value
            })
        },
    }
}
</script>